module.exports = __webpack_public_path__ + "img/fullscreenOutlined.2bc637ce.png";